// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"SearchResult_searchResult__ic6c9","icon":"SearchResult_icon__FX2DB","content":"SearchResult_content__ky4v_"};